export const UPLOAD_STATUS = {
  DONE: 'DONE',
  WRONG: 'HAS_WRONG_DATA',
};
